<app-ag-grid class="full-height lh-34"
             [suppressContextMenu]="true"
             [gridOptions]="{
              suppressDragLeaveHidesColumns: true,
              rowHeight: 35,
              groupHeaderHeight: 64,
              headerHeight: 64,
              colResizeDefault: 'shift'
             }"
             [paginationPageSize]="25"
             [defaultColDef]="defaultColDef"
             [columnDefs]="groupsColumnDefs"
             [loader]="loading$ | async"
             [rowData]="categories$ | async">
  <ng-template #name let-row>
    <app-source [item]="row.payload"></app-source>
  </ng-template>
  <ng-template #count let-row>
    <app-loader [enable]="row.loading$ | async"
                diameter="15">
      <div class="display-flex flex-align-center gap-0-5em">
        {{ row.length$ | async }}
        <mat-icon class="material-icons-outlined icon-info"
                  customToolTip
                  [contentTemplate]="tooltip"
                  *ngIf="row.length$ | async">info</mat-icon>
        <ng-template #tooltip>
          <app-source [item]="item.payload"
                      [enableCategory]="true"
                      *ngFor="let item of row.items$ | async"></app-source>
        </ng-template>
      </div>
    </app-loader>
  </ng-template>
  <ng-template #actions let-row>
    <div class="actions full-height display-flex flex-align-center justify-content-end">
      <app-icon class="display-inline-flex"
                [disabled]="appS.isNotDatasetAdmin || !row.payload.attributes.is_deletable"
                [style]="'material-icons-outlined cursor color-grey-light color-blue-hover'"
                icon="edit"
                [matTooltip]="'tooltip.edit' | translate"
                (onClick)="onUpdate(row)"></app-icon>
      <app-icon class="display-inline-flex"
                [disabled]="appS.isNotDatasetAdmin || !row.payload.attributes.is_deletable || row.payload.attributes.is_deletable && (row.length$ | async)"
                [style]="'material-icons-outlined cursor color-grey-light color-red-hover'"
                icon="delete"
                [matTooltip]="'tooltip.delete' | translate"
                (onClick)="onDelete(row)"></app-icon>
    </div>
  </ng-template>
</app-ag-grid>
